// const googleTagManagerId = process.env.GOOGLE_TAG_MANAGER_ID
const googleTagManagerId = process.env.REACT_APP_GTM

export {
  googleTagManagerId
};